






import ViewModel from '@/views/service/InhabitantDetail.ts';
export default ViewModel;
